import { arrayEquals } from '../utility/arrayHelper';
import { PostSubcategory } from './postCategories';
import { PropertyType } from './propertyTypes';

export enum LandingPageTypes {
  HomePage = 'homepage',
  CondoPage = 'condoPage',
  HousePage = 'housePage',
  TownhomePage = 'townhomePage',
  VacationPage = 'goOnVacationPage',
  HomeOfficePage = 'homeOfficePage',
  CommercialBuildingPage = 'commercialBuildingPage',
  MixedUsePage = 'micksUsePage',
  ProjectResearchPage = 'projectResearchPage',
  LocationInsightPage = 'locationInsightPage',
  ZonesPage = 'zonesPage',
  TrainlinesPage = 'trainlinesPage',
  NewsPage = 'newsPage',
  PropertyNewsPage = 'propertyNewsPage',
  GeneralNewsPage = 'generalNewsPage',
  GuidesPage = 'guidesPage',
  RentPage = 'rentPage',
  BuyAndSellPage = 'buyAndSellPage',
  InvestmentPage = 'investmentPage',
  FinancePage = 'financePage',
  DecorsPage = 'decorPage',
  InteriorInspirationPage = 'interiorInspirationPage',
  RenovationPage = 'renovationPage',
  MaintenancePage = 'maintenancePage',
  ReviewPage = 'projectReviewPage',
  PreviewPage = 'projectPreviewPage',
  PointOfViewPage = 'pointOfViewPage',
  ReviewCondoPage = 'reviewCondoPage',
  ReviewHousePage = 'reviewHousePage',
  ReviewTownhomePage = 'reviewTownhomePage',
  PreviewCondoPage = 'previewCondoPage',
  PreviewHousePage = 'previewHousePage',
  PreviewTownhomePage = 'previewTownhomePage',
  EventPage = 'eventPage',
  SearchResultPage = 'searchResultPage',
  ArticlePage = 'articlePage',
  ProjectPage = 'projectPage',
  ExtraPage = 'extraPage',
}

export type LocationInsightSubLandingPageType =
  | LandingPageTypes.ZonesPage
  | LandingPageTypes.TrainlinesPage;

interface LandingPageInfo {
  pageType: LandingPageTypes;
  propertyType: PropertyType | null;
  postCategories: PostSubcategory[];
}

const landingPageInfos: LandingPageInfo[] = [
  {
    pageType: LandingPageTypes.HomePage,
    propertyType: null,
    postCategories: [],
  },
  {
    pageType: LandingPageTypes.CondoPage,
    propertyType: PropertyType.Condominium,
    postCategories: [],
  },
  {
    pageType: LandingPageTypes.HousePage,
    propertyType: PropertyType.House,
    postCategories: [],
  },
  {
    pageType: LandingPageTypes.TownhomePage,
    propertyType: PropertyType.Townhome,
    postCategories: [],
  },
  {
    pageType: LandingPageTypes.VacationPage,
    propertyType: PropertyType.HolidayHomes,
    postCategories: [],
  },
  {
    pageType: LandingPageTypes.HomeOfficePage,
    propertyType: PropertyType.HomeOffice,
    postCategories: [],
  },
  {
    pageType: LandingPageTypes.CommercialBuildingPage,
    propertyType: PropertyType.Commercial,
    postCategories: [],
  },
  {
    pageType: LandingPageTypes.MixedUsePage,
    propertyType: PropertyType.MixedUse,
    postCategories: [],
  },
  {
    pageType: LandingPageTypes.ProjectResearchPage,
    propertyType: null,
    postCategories: [
      PostSubcategory.Review,
      PostSubcategory.Preview,
      PostSubcategory.PointOfView,
    ],
  },
  {
    pageType: LandingPageTypes.PreviewPage,
    propertyType: null,
    postCategories: [PostSubcategory.Preview],
  },
  {
    pageType: LandingPageTypes.ReviewPage,
    propertyType: null,
    postCategories: [PostSubcategory.Review],
  },
  {
    pageType: LandingPageTypes.PointOfViewPage,
    propertyType: null,
    postCategories: [PostSubcategory.PointOfView],
  },
  {
    pageType: LandingPageTypes.LocationInsightPage,
    propertyType: null,
    postCategories: [PostSubcategory.LocationInsight],
  },
  {
    pageType: LandingPageTypes.NewsPage,
    propertyType: null,
    postCategories: [PostSubcategory.PropertyNews, PostSubcategory.GeneralNews],
  },
  {
    pageType: LandingPageTypes.PropertyNewsPage,
    propertyType: null,
    postCategories: [PostSubcategory.PropertyNews],
  },
  {
    pageType: LandingPageTypes.GeneralNewsPage,
    propertyType: null,
    postCategories: [PostSubcategory.GeneralNews],
  },
  {
    pageType: LandingPageTypes.GuidesPage,
    propertyType: null,
    postCategories: [
      PostSubcategory.BuyAndSell,
      PostSubcategory.Investment,
      PostSubcategory.Rent,
      PostSubcategory.Finance,
    ],
  },
  {
    pageType: LandingPageTypes.BuyAndSellPage,
    propertyType: null,
    postCategories: [PostSubcategory.BuyAndSell],
  },
  {
    pageType: LandingPageTypes.InvestmentPage,
    propertyType: null,
    postCategories: [PostSubcategory.Investment],
  },
  {
    pageType: LandingPageTypes.FinancePage,
    propertyType: null,
    postCategories: [PostSubcategory.Finance],
  },
  {
    pageType: LandingPageTypes.DecorsPage,
    propertyType: null,
    postCategories: [
      PostSubcategory.InteriorInspiration,
      PostSubcategory.Renovation,
      PostSubcategory.Maintenance,
    ],
  },
  {
    pageType: LandingPageTypes.InteriorInspirationPage,
    propertyType: null,
    postCategories: [PostSubcategory.InteriorInspiration],
  },
  {
    pageType: LandingPageTypes.RenovationPage,
    propertyType: null,
    postCategories: [PostSubcategory.Renovation],
  },
  {
    pageType: LandingPageTypes.MaintenancePage,
    propertyType: null,
    postCategories: [PostSubcategory.Maintenance],
  },
  {
    pageType: LandingPageTypes.ReviewCondoPage,
    propertyType: PropertyType.Condominium,
    postCategories: [PostSubcategory.Review],
  },
  {
    pageType: LandingPageTypes.ReviewHousePage,
    propertyType: PropertyType.House,
    postCategories: [PostSubcategory.Review],
  },
  {
    pageType: LandingPageTypes.ReviewTownhomePage,
    propertyType: PropertyType.Townhome,
    postCategories: [PostSubcategory.Review],
  },
  {
    pageType: LandingPageTypes.PreviewCondoPage,
    propertyType: PropertyType.Condominium,
    postCategories: [PostSubcategory.Preview],
  },
  {
    pageType: LandingPageTypes.PreviewHousePage,
    propertyType: PropertyType.House,
    postCategories: [PostSubcategory.Preview],
  },
  {
    pageType: LandingPageTypes.PreviewTownhomePage,
    propertyType: PropertyType.Townhome,
    postCategories: [PostSubcategory.Preview],
  },
];

export function getLandingPageType(
  postCategories?: PostSubcategory[],
  propertyType?: PropertyType,
): LandingPageTypes {
  const sortedPostCategories = [...postCategories].sort();
  return landingPageInfos.find(
    (pageType) =>
      pageType.propertyType == propertyType &&
      arrayEquals([...pageType.postCategories].sort(), sortedPostCategories),
  )?.pageType;
}
